import i18n from "@/i18n";

export function handleApiError(apiError){
    // Add translation here?
    console.warn(apiError && apiError.response && apiError.response.data);
    let errorCode =
        apiError && apiError.response && apiError.response.data && apiError.response.data.error_code ||
        apiError && apiError.message ||
        String(apiError);
    let errorMessage = apiError && apiError.response && apiError.response.data && apiError.response.data.message ||
        apiError && apiError.message ||
        String(apiError);
    console.error(errorCode, errorMessage);
    return handleErrorList(apiError) || [{message: errorMessage, type: "ERROR", code: errorCode}];
}

const STATUS_CODE_MAPPING = {
    null: "GENERIC_ERROR",
    500: "GENERIC_ERROR",
    401: "UNAUTHORIZED_ERROR",
    403: "FORBIDDEN_GENERIC_ERROR",
}


export function makeToast(toaster, msg) {
    toaster.toast(msg, {
        variant: 'success',
        title: 'Επιτυχία',
        solid: true
    })
}


export function makeErrorToast(toaster, msg) {
    let errors = handleApiError(msg);
    errors.forEach(error => {
        toaster.toast(i18n.t(`error.${error.code}`) || "Σφάλμα Εφαρμογής", {
            variant: 'danger',
            title: 'Σφάλμα',
            solid: true
        })
    })

}

export function handleErrorList(apiError){
    // Add translation here?
    let error_list = [];

    if (apiError.response && apiError.response.data && apiError.response.data.errors){
        apiError.response.data.errors.forEach(
            error => {
                console.log(typeof  error)
                if (typeof error === "string"){
                    error_list.push(
                        {message: error, type: "ERROR", code: error});
                }
                else {
                    error_list.push(
                        {message: error.errorMessage, type: error.errorType, code: error.errorCode});
                    console.error(error.errorMessage);
                }

            }
        );
    }
    else if (apiError.response && apiError.response.data && apiError.response.data.error_code) {
        error_list.push(
            {message: apiError.response.data.message, type: apiError.response.data.error_code, code: apiError.response.data.error_code});
    }
    else if (apiError.response && STATUS_CODE_MAPPING[apiError.response.status]){
        error_list.push(
            {message: STATUS_CODE_MAPPING[apiError.response.status], type: "ERROR", code: STATUS_CODE_MAPPING[apiError.response.status]});
    }
    else {
        error_list.push(
            {message: STATUS_CODE_MAPPING[null], type: "ERROR", code: STATUS_CODE_MAPPING[null]});
    }
    return error_list;
}
